import { render, staticRenderFns } from "./Derivatives.vue?vue&type=template&id=e0066ba6&scoped=true"
import script from "./Derivatives.vue?vue&type=script&lang=ts&setup=true"
export * from "./Derivatives.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Derivatives.vue?vue&type=style&index=0&id=e0066ba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0066ba6",
  null
  
)

export default component.exports